import React from 'react';
import { useForm, FormProvider } from 'react-hook-form';

// lodash
import _ from 'lodash';

// components
import { Box, Typography } from '@mui/material';
import { useSingleFormValidationResolver } from '../hooks';
import { AccountOrgContactDefaultFields } from './fields/AccountOrganizationContactDefaultFields';
import { AccountFieldsContainer } from './profile/AccountFieldsContainer';
import { AccountOrgContactSchema } from './_validations/DefaultAccountValidations';
/* eslint-enable no-template-curly-in-string */

const defaultValuesKeys = [
  'contactFirstName',
  'contactLastName',
  'contactEmail',
  'contactPhone',
];

export const AccountOrgContactForm = ({
  formId = 'orgContact',
  formName = 'Organization Contact',
  children,
  defaultValues = {},
  disabled = false,
  handleOnSubmit,
  registerForm = () => null,
  validationSchema = AccountOrgContactSchema,
  reportErrors,
  FieldsContainer = AccountFieldsContainer,
}: any) => {
  const resolver = useSingleFormValidationResolver(validationSchema, {
    formId,
    formName,
    reporter: reportErrors,
  });

  const { handleSubmit, ...methods } = useForm({
    defaultValues: _.pick(defaultValues, defaultValuesKeys),
    resolver,
  });

  function onSubmit(values: any) {
    return handleOnSubmit(values, validationSchema, formId, formName).then(
      (finalValues: any) => {
        const nextValues = finalValues || values;
        methods.reset({ ...nextValues });
        return nextValues;
      }
    );
  }

  React.useEffect(() => {
    registerForm({
      id: formId,
      name: formName,
      handler: handleSubmit(onSubmit),
      reset: methods.reset,
    });
    // eslint-disable-next-line
  }, []);

  return (
    // @ts-expect-error TS(2741): Property 'handleSubmit' is missing in type '{ chil... Remove this comment to see the full error message
    <FormProvider {...methods}>
      <form id={formId} onSubmit={handleSubmit(onSubmit)}>
        {typeof children === 'function' ? (
          children()
        ) : (
          <>
            <Box display="flex" justifyContent="space-between">
              <Typography
                variant="h3"
                className="primer-text contrast-text"
                paragraph
              >
                {formName}
              </Typography>
            </Box>
            <FieldsContainer>
              <AccountOrgContactDefaultFields disabled={disabled} />
            </FieldsContainer>
          </>
        )}
      </form>
    </FormProvider>
  );
};
